import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { GET, POST, httpOk } from 'helpers/api'
import Pagination from 'pages/parts/Pagination'

function Index() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [data, setData] = useState([])
	const [unread, setUnread] = useState(0)
	const [pageCount, setPageCount] = useState(0)
	const [currentPage, setCurrentPage] = useState(0)
	const pageSize = 20

	async function getData(page = 0) {
		const response = await GET(`/notifications?page=${page}&size=${pageSize}`, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data)
			setUnread(response.data.unread ?? 0)
			setPageCount(Math.ceil((response.data.total ?? 0) / pageSize))
		}
	}

	// ids пустой => отметить все непрочитанные
	async function markRead(ids = []) {
		const response = await POST('/notifications/read', { ids }, { notification: false })
		if (httpOk(response)) getData(currentPage)
	}

	function paginate(page) {
		setCurrentPage(page.selected)
		getData(page.selected)
	}

	// Клик по уведомлению: отметить прочитанным и увести на экран действия (action_url с бэка)
	function openNotification(item) {
		if (!item.is_read) markRead([item.id])
		if (!item.action_url) return

		navigate(item.action_url)
	}

	// "2026-08-15 18:25:46.569338" -> "15.08.26 18:25"
	function formatNotifDate(raw) {
		if (!raw) return ''
		const m = String(raw).replace('T', ' ').match(/^(\d{4})-(\d{2})-(\d{2})[ ]+(\d{2}):(\d{2})/)
		if (!m) return raw
		return `${m[3]}.${m[2]}.${m[1].slice(2)} ${m[4]}:${m[5]}`
	}

	useEffect(() => {
		getData(0)
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="d-flex justify-content-between align-items-center mb-3">
				<h4 className="mb-0 d-flex align-items-center">
					{t('notification_center')}
					{unread > 0 &&
						<span className="badge bg-danger ms-2" style={{ 'fontSize': '.78rem' }}>{unread}</span>
					}
				</h4>
				{unread > 0 &&
					<button className="btn btn-sm btn-outline-primary" onClick={() => markRead([])}>
						{t('mark_all_read')}
					</button>
				}
			</div>

			<div style={{ 'display': 'flex', 'flexDirection': 'column', 'gap': '10px' }}>
				{data.map((item, index) => (
					<div key={index} className="card mb-0"
						onClick={() => openNotification(item)}
						style={{
							'borderLeft': '4px solid ' + (item.is_read ? 'var(--dark-border, #e5e7eb)' : '#2563a8'),
							'background': item.is_read ? 'var(--dark-surface, #fff)' : 'var(--dark-surface-2, #f6f9ff)',
							'cursor': (item.action_url || !item.is_read) ? 'pointer' : 'default',
						}}>
						<div className="card-body" style={{ 'padding': '14px 16px' }}>
							<div className="d-flex justify-content-between align-items-center" style={{ 'marginBottom': '8px' }}>
								<span className="badge" style={{ 'color': 'var(--dark-fg-primary, #2563a8)', 'background': 'var(--dark-tint-primary, #e7effb)', 'fontSize': '.76rem' }}>
									{formatNotifDate(item.created_at)}
								</span>
								{!item.is_read &&
									<div className="table-action-button table-action-success-button d-inline-flex"
										title={t('mark_read')}
										onClick={(e) => { e.stopPropagation(); markRead([item.id]) }}>
										<i className="uil uil-check"></i>
									</div>
								}
							</div>
							{item.title &&
								<div className="fw-600" style={{ 'color': 'var(--dark-text-strong, #14181f)', 'marginBottom': '2px' }}>{item.title}</div>
							}
							<div style={{ 'color': 'var(--dark-text, #4b5563)', 'fontSize': '.9rem', 'lineHeight': 1.5 }}>{item.message}</div>
							{item.action_url &&
								<div className="fw-600" style={{ 'color': 'var(--dark-fg-primary, #2563a8)', 'fontSize': '.82rem', 'marginTop': '6px' }}>
									{t('go_to_action')} <i className="uil uil-angle-right-b"></i>
								</div>
							}
						</div>
					</div>
				))}
				{data.length === 0 &&
					<div className="card mb-0">
						<div className="card-body text-center text-muted">{t('no_notifications')}</div>
					</div>
				}
				<Pagination pageCount={pageCount} paginate={paginate}></Pagination>
			</div>
		</>
	)
}

export default Index
